module.exports = __webpack_public_path__ + "static/media/zillow.0c1337ea.svg";